export default __webpack_public_path__ + "static/media/successful_sl.25db630a.png";